import React from "react";
import AppLoader from "../Common/AppLoader";
import { getSourceBadgeInfo } from "../../utils/leadSourceHelper";

const MobileLeadCards=({ leads=[], loading, navigate, selectedLeadIds=[], handleLeadSelect, hideCheckbox=false, onLeadClick })=>{

  if(loading){
    return (
      <div className="text-center py-5">
        <AppLoader/>
      </div>
    );
  }

  if(!leads.length){
    return (
      <div className="text-center py-5">
        No Leads Found
      </div>
    );
  }

  const handleCardClick = (l) => {
    try {
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      sessionStorage.setItem("user_leads_scroll_pos", scrollY.toString());
      sessionStorage.setItem("all_leads_scroll_pos", scrollY.toString());
      sessionStorage.setItem("new_leads_scroll_pos", scrollY.toString());
      sessionStorage.setItem("last_viewed_lead_id", l._id);
    } catch (e) {}
    if (onLeadClick) {
      onLeadClick(l);
    } else if (navigate) {
      navigate(`/lead-details/${l.source}/${l._id}`);
    }
  };

  return (
    <div className="mobile-leads-list">

      {leads.map((l,index)=>(
        <div
          key={l._id}
          id={`lead-card-${l._id}`}
          className="mobile-lead-card"
          onClick={() => handleCardClick(l)}
        >

          <div className="mobile-lead-header">

            {
              !hideCheckbox && (
                <label
                  className={`crm-checkbox ${
                    selectedLeadIds.includes(l._id)
                      ? "active"
                      : ""
                  }`}
                  onClick={(e)=>{
                    e.stopPropagation();
                    handleLeadSelect(l)
                  }}
                >
                  <span />
                </label>
              )
            }

            <div className="flex-grow-1">

              <div className="mobile-lead-id">
                #{index + 1}
              </div>

              <h5 className="mobile-lead-name">
                {l.name || "-"}
              </h5>

            </div>

            <i className="mdi mdi-chevron-right text-muted fs-4" />

          </div>

          <div className="mobile-lead-contact">

            {l.email && (
              <div>
                <i className="mdi mdi-email-outline me-1" />
                {l.email}
              </div>
            )}

            {l.phone && (
              <div>
                <i className="mdi mdi-phone-outline me-1" />
                {l.phone}
              </div>
            )}

          </div>

          <div className="mobile-lead-info">

            <div>
              <span className="text-muted">
                Project :
              </span>{" "}
              {l.projectName || "-"}
            </div>

            <div>
              <span className="text-muted"> Source : </span>{" "}
              {(() => {
                const badgeInfo = getSourceBadgeInfo(l.source);
                const isFacebook = badgeInfo.label === "Facebook";

                return (
                  <span>
                    <span className={`d-inline-flex align-items-center fw-semibold ${badgeInfo.textColor || "text-info"}`}>
                      <i className={`${badgeInfo.icon} me-1`} />
                      {badgeInfo.label}
                    </span>
                    {isFacebook && l.formName && l.formName !== "-" && (
                      <>
                        <br />
                        <small className="text-muted"> {l.formName} </small>
                      </>
                    )}
                    {isFacebook && l.pageName && l.pageName !== "-" && (
                      <>
                        <br />
                        <span className="badge bg-primary mt-1"> {l.pageName} </span>
                      </>
                    )}
                    {!isFacebook && l.formName && l.formName !== "-" && (
                      <>
                        <br />
                        <small className="text-muted"> {l.formName} </small>
                      </>
                    )}
                  </span>
                );
              })()}
            </div>

            <div>
              <span className="text-muted">
                Assigned :
              </span>{" "}
              {l.assignedTo || "-"}
            </div>

          </div>

          <div className="mobile-lead-footer">

            <div className="d-flex align-items-center gap-1">
              <span className="badge bg-primary">
                {l.stage || "-"}
              </span>
              {l.remark && (
                <span className="badge bg-warning text-dark">
                  {l.remark}
                </span>
              )}
            </div>

            <small className="text-muted">
              {
                l.createdTime
                  ? new Date(l.createdTime).toLocaleString(
                      "en-GB",
                      {
                        day:"2-digit",
                        month:"short",
                        year:"numeric",
                        hour:"2-digit",
                        minute:"2-digit",
                      }
                    )
                  : "-"
              }
            </small>

          </div>

        </div>
      ))}

    </div>
  );
};

export default MobileLeadCards;